import type { OperatingModule } from "../api/operatingMode";

/**
 * Quyền này thuộc vùng nghiệp vụ nào, hoặc `undefined` khi nó không thuộc vùng nào có thể tắt.
 *
 * Dùng để lọc ma trận phân quyền (ADR-0053): phòng khám không dùng vùng Tài chính thì các dòng
 * quyền hoá đơn chỉ là nhiễu — chủ phòng khám không cấp được thứ gì có nghĩa từ chúng.
 *
 * Suy từ tiền tố của mã quyền, vốn là quy ước đặt tên của `permissions` (`billing.invoice.write`,
 * `encounter.read`…). Quyền không khớp tiền tố nào thì luôn hiện: sót một dòng thừa vô hại, còn ẩn
 * nhầm một quyền thật thì chủ phòng khám không cấp được nó.
 */
const PREFIXES: Array<[prefix: string, module: OperatingModule]> = [
  ["encounter.", "ENCOUNTERS"],
  ["prescription.", "PRESCRIPTIONS"],
  ["inventory.", "INVENTORY"],
  ["billing.", "BILLING"],
  ["vaccination.", "VACCINATION"],
  ["report.", "REPORTS"],
];

export function moduleOfPermission(code: string): OperatingModule | undefined {
  return PREFIXES.find(([prefix]) => code.startsWith(prefix))?.[1];
}
